import ContentCurationManager from './ContentCurationManager'

const CategoryContentCurationManager = (props) => (
  <ContentCurationManager
    description={props.description}
    visibilityText='Show curated list'
    communityListVisibilityText='Show community list'
    showCommunityListVisibility
    searchPlaceholder='Search for topics or enter a topic URL'
    onUpdate={(key, value) => props.onChange({ [key]: value })}
    {...props.contentCuration}
  />
)

export default CategoryContentCurationManager
